//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {mapGetters, mapMutations} from "vuex";

export default {
  name: "ConfirmDialog",

  computed: {
    ...mapGetters([
      'showDialog'
    ])
  },

  methods: {
    ...mapMutations({
      displayError: 'displayError',
      setNewModel: 'setNewModel',
      setShowDialog: 'setShowDialog',
    }),
    abort() {
      this.setShowDialog(false);
      this.setNewModel({});
      this.$router.push({name: 'dashboard'});
    },
    cancel() {
      this.setShowDialog(false);
    },
  }
}
